"use client";

import { Badge } from "@/components/ui/badge";
import { siteConfig } from "@/lib/siteConfig";
import { Spotlight } from "@/components/motion-primitives/spotlight";
import { motion } from "motion/react";

export default function WhyChoose() {
  return (
    <section className="wrapper square-gradient-bg relative py-14 squaresBg">
      <div className={"flex flex-col gap-5 items-center"}>
        <Badge variant={"default"}>Why Choose VisionTech</Badge>
        <h1 className={"text-4xl text-center font-bold"}>
          Your Trusted Partner for{" "}
          <span className={"text-primary"}>Technology Solutions</span>
        </h1>
        <div
          className={
            "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5 mt-5"
          }
        >
          {siteConfig.whyUsPoints.map((point, index) => (
            <motion.div
              initial={{ opacity: 0, y: 150 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              key={index}
            >
              <div className="square-gradient-bg   text-background bg-background h-full transition-all duration-500 hover:shadow-2xl hover:shadow-emerald-500/10">
                {" "}
                <Spotlight
                  className="bg-primary blur-2xl"
                  size={64}
                  springOptions={{
                    bounce: 0.3,
                    duration: 0.1,
                  }}
                />
                <div
                  className={
                    "flex flex-col gap-2 items-center text-center rounded p-8"
                  }
                >
                  <div
                    className={
                      "grid place-content-center p-5 rounded-full bg-primary"
                    }
                  >
                    <point.icon className={"text-white"} />
                  </div>
                  <h2 className={"text-2xl font-bold text-primary"}>
                    {point.title}
                  </h2>
                  <p className={"text-muted-foreground text-sm font-semibold"}>
                    {point.description}
                  </p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
